import clsx from "clsx";
import React, { forwardRef, useMemo } from "react";
import { createUseStyles } from "react-jss";

import { spacing } from "../style/spacing";

const useStyles = createUseStyles({
  root: (props: any) => ({
    ...spacing(props),
    outline: "none",
    width: props.width || (props.fullWidth && "100%") || "",
    height: props.height,
    overflowY: props.overflowY,
  }),
});

const ButtonKinds = {
  Primary: "primary",
  Secondary: "secondary",
  SecondarySmall: "secondary-small",
  ClassroomPrimary: "classroom-primary",
  ClassroomSecondary: "classroom-secondary",
  GradingPrimary: "grading-primary",
  PrimaryMobile: "primary-mobile",
  SecondaryMobile: "secondary-mobile",
  PrimaryMobileBreakout0: "primary-mobile-breakout-0",
  PrimaryMobileBreakout1: "primary-mobile-breakout-1",
  PrimaryMobileBreakout2: "primary-mobile-breakout-2",
  PrimaryMobileBreakout3: "primary-mobile-breakout-3",
  PrimaryMobileBreakout4: "primary-mobile-breakout-4",
  PrimaryMobileBreakout5: "primary-mobile-breakout-5",
  PrimaryMobileBreakout6: "primary-mobile-breakout-6",
  PrimaryMobileBreakout7: "primary-mobile-breakout-7",
  IconTextSecondaryMobile: "icon-text-secondary-mobile",
  Text: "text",
  TextSmall: "text-small",
  TextClassroomPrimary: "text-classroom-primary",
  TextClassroomSecondary: "text-classroom-secondary",
};

const Button = forwardRef<any, any>((props, ref) => {
  const {
    autoFocus,
    children,
    className,
    disabled,
    kind = ButtonKinds.Primary,
    loading,
    name,
    onClick,
    icon,
    type = "button",
  } = props;
  const fdsClass = useMemo(mkFdsClass, [kind, icon]);
  const css = useStyles(props);

  return (
    <button
      autoFocus={autoFocus}
      className={clsx(fdsClass, css.root, className)}
      disabled={disabled || loading}
      name={name}
      onClick={handleClick}
      ref={ref}
      /* eslint-disable-next-line react/button-has-type */
      type={type}
      // The padding is set to 0 during the loading animation so that it can take over the full
      // content size of the button, otherwise the loading animation looks squished.
      {...(loading ? { "data-loading": true, style: { padding: "0" } } : {})}
      data-testid={props["data-testid"] || "Button"}
      aria-label={props["aria-label"]}
    >
      {icon}
      {loading ? (
        // The height was determined by the height of the button in FDS
        <span
          className="svg-icon loading-darkbg"
          style={{ width: "100%", height: "36px" }}
        />
      ) : (
        children
      )}
    </button>
  );

  function handleClick(event) {
    onClick?.(event);
  }

  function mkFdsClass() {
    let classStr = "";
    classStr += icon ? "icon-" : "";
    classStr += `button-${kind}`;
    return classStr;
  }
});

export { Button, ButtonKinds };
